import { all } from 'redux-saga/effects';
import { notificationsPackageSaga } from 'unbrace/notifications-micro-package';
import securitySaga from '../../../security/redux/sagas';
import alertsSaga from './alerts';
import filtersSaga from './filters';

export default function* rootSaga() {
  yield all([notificationsPackageSaga(), securitySaga(), alertsSaga(), filtersSaga()]);
}
